export const LOG_STATUSES = {
  new: { label: 'Новая', variant: 'danger' as const },
  'in-progress': { label: 'В работе', variant: 'primary' as const },
  resolved: { label: 'Решена', variant: 'info' as const },
  ignored: { label: 'Игнорируется', variant: 'outline' as const },
};

export const LOG_TYPES = {
  api: 'API',
  system: 'Система',
  user: 'Пользователь',
  payment: 'Оплата',
  booking: 'Бронирование',
};

export const LOG_SERVICES = {
  'scat-airlines': 'SCAT Airlines',
  'air-astana': 'Air Astana',
  'flyarystan': 'FlyArystan',
  'payment-gateway': 'Платежная система',
  'booking-system': 'Система бронирования',
};

export const FILTER_OPTIONS = {
  eventTypes: [
    { value: 'all', label: 'Все события' },
    { value: 'API', label: 'API' },
    { value: 'PAYMENT_ERROR', label: 'Ошибка оплаты' },
    { value: 'API_ERROR', label: 'Ошибка API' },
  ],
  services: [
    { value: 'all', label: 'Все сервисы' },
    { value: 'push', label: 'Push' },
    { value: 'payment', label: 'Платежи' },
    { value: 'airline', label: 'Авиакомпания' },
  ],
  statuses: [
    { value: 'all', label: 'Все статусы' },
    { value: 'new', label: 'Новая' },
    { value: 'in_progress', label: 'В работе' },
    { value: 'resolved', label: 'Решена' },
    { value: 'ignored', label: 'Игнорируется' },
  ],
  periods: [
    { value: 'all', label: 'Весь период' },
    { value: 'today', label: 'Сегодня' },
    { value: 'week', label: 'Неделя' },
    { value: 'month', label: 'Месяц' },
    { value: 'custom', label: 'Произвольный' },
  ],
};
const INCIDENT_SERVICES: Record<string, string> = {
  push: "Push",
  payment: "Платежи",
  airline: "Авиакомпания",
};